import _ from 'lodash'
import appConf from '../../../../../conf/appConf'
import authUtil from '../../../../lib/authUtil'
import confUtil from '../../../../lib/confUtil'

const SellerLogout = () => {
  return null
}

const COOKIE_CONFIG = {
  // expired immediately
  maxAge: 0,
  domain: 'yahoo.com',
  httpOnly: true,
  secure: true,
  encode: String
}

const SIMULATE_SELLER_COOKIES = [
  appConf.oktaAtCookieKey,
  appConf.oktaItCookieKey
]

const SELLER_COOKIES = [
  appConf.yahooYCookieKey,
  appConf.yahooTCookieKey
]

// Overrides default preFetcher in app.server.js
SellerLogout.preFetcher = async ({ store, req, res }) => {
  const envConf = _.get(store.getState(), 'page.envConf', {})
  const { isOktaCookie, isYCookie } = authUtil(req)
  const cookieKeys = [
    appConf.seCookieKey,
    ...(isYCookie ? SELLER_COOKIES : []),
    ...(isOktaCookie ? SIMULATE_SELLER_COOKIES : [])
  ]
  for (const cookieKey of cookieKeys) {
    if (SELLER_COOKIES.includes(cookieKey)) {
      res.clearCookie(cookieKey, COOKIE_CONFIG)
    } else {
      res.clearCookie(cookieKey, {
        ...COOKIE_CONFIG,
        domain: 'supplier.yahoo.com'
      })
    }
  }

  if (isOktaCookie) {
    // 導向模擬登入頁
    res.redirect(confUtil.getAbsUrl(envConf)('sellerSimulateLogin'))
    return Promise.resolve()
  }

  // 導向店家後台登入頁
  res.redirect(confUtil.getAbsUrl(envConf)('sellerLogin'))
  return Promise.resolve()
}

export default SellerLogout
